"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseIWorkOrderSearchEntity = void 0;
const iactivity_search_entity_sort_1 = require("./iactivity-search-entity-sort");
const iwork_order_search_filter_entity_1 = require("./iwork-order-search-filter-entity");
const iwork_order_search_show_entity_1 = require("./iwork-order-search-show-entity");
function parseIWorkOrderSearchEntity(data) {
    if (data.sort !== null && typeof data.sort === 'object')
        data.sort = (0, iactivity_search_entity_sort_1.parseIActivitySearchEntitySort)(data.sort);
    if (data.filter !== null && typeof data.filter === 'object')
        data.filter = (0, iwork_order_search_filter_entity_1.parseIWorkOrderSearchFilterEntity)(data.filter);
    if (data.show !== null && typeof data.show === 'object')
        data.show = (0, iwork_order_search_show_entity_1.parseIWorkOrderSearchShowEntity)(data.show);
    return data;
}
exports.parseIWorkOrderSearchEntity = parseIWorkOrderSearchEntity;
